<template>
    <div class="border-b-2 mx-4 py-3 step-container" ref="stepContainer"
        :class="[{'border-t-2 pt-4': (step == 1)}, 'step-' + step]">
        <!-- Step header -->
        <div class="step-heading flex"
             :class="wrapperClasses"
             @click="goTo(step)"
        >
            <div class="step-icon" :class="iconClasses" :style="style" v-if="icon">&nbsp;</div>
            <div>
                <div class="step-number">Schritt {{ step }}</div>
                <div class="step-name">{{ title }} <Popover v-if="info" :text="info"></Popover></div>
            </div>
        </div>

        <!-- step body -->
        <div v-if="step == currentStep" class="step-content">
            <slot></slot>
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import Popover from '~/scripts/Components/Popover.vue';

export default {
    components: {
        Popover
    },
    props: {
        title: String,
        step: Number,
        icon: String,
        info: String
    },
    computed: {
        ...mapFields({
            'theme': 'theme',
            'currentStep': 'step',
            'soundFiles': 'soundFiles',
            'stepsDisabled': 'stepsDisabled',
        }),
        isActive() {
            return (this.step === this.currentStep);
        },
        isDisabled() {
            // disable all steps before theme has been chosen
            if(!this.currentStep) {
                return true;
            }

            // if no sound file has been recorded: disable steps
            if(this.step > 1 && this.soundFiles.length === 0) {
                return true;
            }

            if(this.stepsDisabled.indexOf(this.step) !== -1) {
                return true;
            }

            return false;
        },
        wrapperClasses() {
            let classList = [];

            if(this.isActive) {
                classList.push('active');
            }

            if(!this.isDisabled && !this.isActive) {
                classList.push('cursor-pointer');
            }

            classList.push(this.isDisabled ? 'disabled' : '');

            return classList;
        },

        iconClasses() {
            let classList = [];

            classList.push(this.isDisabled ? 'text-gray-300' : 'text-orange')

            return classList;
        },

        style() {
            if (this.icon) {
                return { backgroundImage: `url(/build/public/images/icons/${this.icon}.svg)` }
            }

            return {};
        }
    },
    methods: {
        goTo(step) {
            if(this.isDisabled) {
                return;
            }

            this.currentStep = step;
        }
    }
}
</script>
